import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'rappider-form-with-guidance',
  templateUrl: './form-with-guidance.component.html',
  styleUrls: ['./form-with-guidance.component.scss'],
})
export class RappiderFormWithGuidanceComponent {
  @Input() editFormConfig;
  @Input() content;
  @Input() errorAlertConfig;
  @Input() submitButtonLoading = false;

  @Output() formSubmit = new EventEmitter();

  onFormSubmit(form) {
    this.formSubmit.emit(form);
  }

}
